import { Size } from '@/hooks/useScreenSize';

const paymentContainerClassMap: Record<Size, string> = {
  sm: 'flex w-full flex-col  gap-12  text-color-content-text-primary items-center justify-center',
  md: 'flex  flex-col  items-center justify-center h-auto gap-12 pl-2 text-color-content-text-primary ',
  lg: 'flex w-full flex-col  gap-12 pl-10 text-color-content-text-primary w-[586px]  items-center',
  xl: 'flex w-full flex-col  gap-12 pl-2 text-color-content-text-primary items-center',
  xxl: 'flex w-full flex-col  gap-12 pl-2 text-color-content-text-primary w-[1001px] items-center',
};

const paymentHeadingClassMap: Record<Size, string> = {
  sm: 'text-color-content-text-primary text-font-size-bold-font-size-14 font-[700] leading-lineHeight-lg w-[328px] h-[42px] flex items-center',
  md: 'pt-[1.2rem]  text-color-content-text-primary text-font-size-bold-font-size-14 font-[700] leading-lineHeight-lg w-[426px] h-[42px] flex items-center',
  lg: 'pt-[1.2rem]  text-color-content-text-primary text-font-size-bold-font-size-20 font-[700] leading-lineHeight-xs w-[554px] h-[42px] flex items-center',
  xl: 'pt-[1.2rem]  text-color-content-text-primary text-font-size-bold-font-size-20 font-[700] leading-lineHeight-xs w-[554px] h-[42px] flex items-center',
  xxl: 'pt-[1.2rem]  text-color-content-text-primary text-font-size-bold-font-size-24 font-[700] leading-lineHeight-sm w-[721px] h-[42px] flex items-center',
};
const paymentCardContainerClassMap: Record<Size, string> = {
  sm: 'flex flex-col items-center',
  md: 'flex flex-col items-center',
  lg: 'flex flex-col items-end',
  xl: 'flex flex-col items-end',
  xxl: 'flex flex-col items-end',
};

const cardsContainerClassMap: Record<Size, string> = {
  sm: 'my-4 flex h-[64px] max-w-[328px] flex-row items-center gap-spacing-none rounded-radius-sm border-[1px] border-solid border-color-border-miniCards-primary bg-color-background-miniCard-default pt-[11px] pr-spacing-lg pb-[11px] pl-spacing-xs ',
  md: 'my-4 flex h-[83.2px] w-[426.4px] flex-row items-center gap-spacing-none rounded-radius-md border-[1.3px] border-solid border-color-border-miniCards-primary bg-color-background-miniCard-default pt-[14.3px] pr-[31.2px] pb-[14.3px] pl-[20.8px]',
  lg: 'my-4 flex h-[108.16px] w-[554.32px] flex-row items-center gap-spacing-none  rounded-radius-lg border-[1.69px] border-solid border-color-border-miniCards-primary bg-color-background-miniCard-default pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] ',
  xl: 'my-4 flex h-[108.16px] w-[554.32px] flex-row items-center gap-spacing-none  rounded-radius-lg border-[1.69px] border-solid border-color-border-miniCards-primary bg-color-background-miniCard-default pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px]',
  xxl: 'my-4 flex h-[140.61px] w-[720.62px] flex-row items-center gap-spacing-none rounded-radius-xl border-[2.197px] border-solid border-color-border-miniCards-primary bg-color-background-miniCard-default pt-[24.167px] pr-[52.728px] pb-[24.167px] pl-[35.152px] ',
};

const selectedCardClassMap: Record<Size, string> = {
  sm: 'border-solid border-[0.89px] rounded-radius-sm py-[11px] px-[16px] !border-active-card-border bg-color-background-miniCard-selected',
  md: 'border-solid border-[1.163px] rounded-radius-md py-[14.3px] px-[20.8px] !border-active-card-border bg-color-background-miniCard-selected',
  lg: 'border-solid border-[1.511px] rounded-radius-lg py-[18.59px] px-[27.04px] !border-active-card-border bg-color-background-miniCard-selected',
  xl: 'border-solid border-[1.511px] rounded-radius-lg py-[18.59px] px-[27.04px] !border-active-card-border bg-color-background-miniCard-selected',
  xxl: 'border-solid border-[1.965px] rounded-radius-xl py-[24.167px] px-[35.152px] !border-active-card-border bg-color-background-miniCard-selected',
};
const imageTextContainerClassMap: Record<Size, string> = {
  sm: 'flex h-[41px] w-[258px] gap-[16px] flex-row items-center flex-shrink-0',
  md: 'flex h-[53.3px] w-[335.4px] flex-row items-center gap-[20.8px] flex-shrink-0',
  lg: 'flex h-[69.29px] w-[436.02px] flex-row items-center gap-[27.04px] flex-shrink-0',
  xl: 'flex h-[69.29px] w-[436.02px] flex-row items-center gap-[27.04px] flex-shrink-0',
  xxl: 'flex h-[90.08px] w-[566.83px] flex-row items-center gap-[35.152px] flex-shrink-0',
};
const cardIconClassMap: Record<Size, string> = {
  sm: 'h-[41px] w-[41px]',
  md: 'h-[53.3px] w-[53.3px]',
  lg: 'h-[69.29px] w-[69.29px]',
  xl: 'h-[69.29px] w-[69.29px]',
  xxl: 'h-[90.08px] w-[90.08px]',
};
const cardIconSizeMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 41, height: 41 },
  md: { width: 53.3, height: 53.3 },
  lg: { width: 69.29, height: 69.29 },
  xl: { width: 69.29, height: 69.29 },
  xxl: { width: 90.08, height: 90.08 },
};
const bankIconPaddingSizeMap: Record<Size, string> = {
  sm: 'px-[2px] pt-[6px] pb-[5px]',
  md: 'px-[2px] pt-[6px] pb-[5px]',
  lg: 'px-[2.7px] pt-[8.1px] pb-[6.75px]',
  xl: 'px-[2.7px] pt-[8.1px] pb-[6.75px]',
  xxl: 'px-[3.5px] pt-[10.5px] pb-[8.75px]',
};
const cardTitleClassMap: Record<Size, string> = {
  sm: 'self-center pt-2  text-fontSize-paragraph-body-sm font-[450] leading-lineHeight-xl text-color-content-text-primary',
  md: 'self-center pt-2  text-fontSize-paragraph-body-md font-[450] leading-lineHeight-2xl text-color-content-text-primary',
  lg: 'self-center pt-2  text-fontSize-paragraph-body-lg font-[450] leading-lineHeight-4xl text-color-content-text-primary',
  xl: 'self-center  pt-2  text-fontSize-paragraph-body-lg font-[450] leading-lineHeight-4xl text-color-content-text-primary',
  xxl: 'self-center  pt-2  text-fontSize-paragraph-body-xl font-[450] leading-lineHeight-7xl text-color-content-text-primary',
};

const checkBoxContainerClassMap: Record<Size, string> = {
  sm: 'w-full py-[2px]',
  md: 'w-full py-[2.6px]',
  lg: 'w-full py-[3.38px]',
  xl: 'w-full py-[3.38px]',
  xxl: 'w-full py-[7.39px]',
};
const checkBoxRowClassMap: Record<Size, string> = {
  sm: 'w-full !items-start !gap-[16px]',
  md: 'w-full !items-start !gap-[20.8px]',
  lg: 'w-full !items-start !gap-[27.04px]',
  xl: 'w-full !items-start !gap-[35.15px]',
  xxl: 'w-full !items-start !gap-[35.15px]',
};
const checkBoxClassMap: Record<Size, string> = {
  sm: '!w-[24px] !h-[24px] !rounded-[2px] !border-2 border-color-border-checkbox-secondary text-sm text-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-background-icons-primary-primary',
  md: '!w-[30px] !h-[30px] !rounded-[4px] !border-[2.6px] border-color-border-checkbox-secondary text-sm text-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-background-icons-primary-primary',
  lg: '!w-[38.9px] !h-[38.9px] !rounded-[4px] !border-[3.38px] border-color-border-checkbox-secondary text-md text-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-background-icons-primary-primary',
  xl: '!w-[38.9px] !h-[38.9px] !rounded-[4px] !border-[3.38px] border-color-border-checkbox-secondary text-md text-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-background-icons-primary-primary',
  xxl: '!w-[43.9px] !h-[43.9px] !rounded-[4px] !border-[4.39px] border-color-border-checkbox-secondary text-color-border-checkbox-secondary checked:bg-color-background-icons-checkbox-active-Square checked:text-color-background-icons-primary-primary',
};
const checkBoxLabelClassMap: Record<Size, string> = {
  sm: 'flex-1 font-[450] text-[14px] leading-[20px] text-color-content-text-secondary py-[2px]',
  md: 'flex-1 font-[450] text-[16px] leading-[24px] text-color-content-text-secondary py-[2.7px]',
  lg: 'flex-1 font-[450] text-[20px] leading-[28px] text-color-content-text-secondary py-[3.38px]',
  xl: 'flex-1 font-[450] text-[20px] leading-[28px] text-color-content-text-secondary py-[3.38px]',
  xxl: 'flex-1 font-[450] text-[24px] leading-[36px] text-color-content-text-secondary py-[4.39px]',
};
const checkBoxLinkLabelClassMap: Record<Size, string> = {
  sm: 'font-[700] text-[14px] leading-[20px] text-color-content-text-primary underline',
  md: 'font-[700] text-[16px] leading-[24px] text-color-content-text-primary underline',
  lg: 'font-[700] text-[14px] leading-[20px] text-color-content-text-primary underline',
  xl: 'font-[700] text-[16px] leading-[20px] text-color-content-text-primary underline',
  xxl: 'font-[700] text-[20px] leading-[20px] text-color-content-text-primary underline',
};
const creditCheckMessageClassMap: Record<Size, string> = {
  sm: 'font-[450] text-[10px] leading-[16px] text-color-content-text-secondary py-[4px]',
  md: 'font-[450] text-[12px] leading-[18px] text-color-content-text-secondary py-[4px]',
  lg: 'font-[450] text-[12px] leading-[18px] text-color-content-text-secondary py-[4px]',
  xl: 'font-[450] text-[12px] leading-[18px] text-color-content-text-secondary',
  xxl: 'font-[450] text-[16px] leading-[24px] text-color-content-text-secondary py-[4.05px]',
};
const creditCheckLinkLabelClassMap: Record<Size, string> = {
  sm: 'font-[450] text-[10px] leading-[16px] text-color-content-text-primary underline',
  md: 'font-[450] text-[12px] leading-[18px] text-color-content-text-primary underline',
  lg: 'font-[450] text-[12px] leading-[18px] text-color-content-text-primary underline',
  xl: 'font-[450] text-[12px] leading-[18px] text-color-content-text-primary underline',
  xxl: 'font-[450] text-[16px] leading-[24px] text-color-content-text-primary underline',
};
const checkBoxIconClassMap: Record<Size, string> = {
  sm: '!w-[24px] !h-[24px] !p-[5px] text-color-background-icons-primary-primary',
  md: '!w-[30px] !h-[30px] !p-[6px] text-color-background-icons-primary-primary',
  lg: '!w-[38.9px] !h-[38.9px] !p-[8px] text-color-background-icons-primary-primary',
  xl: '!w-[38.9px] !h-[38.9px] !p-[8px] text-color-background-icons-primary-primary',
  xxl: '!w-[43.9px] !h-[43.9px] !p-[9px] text-color-background-icons-primary-primary',
};

const iconClassMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 30, height: 30 },
  md: { width: 39, height: 39 },
  lg: { width: 50.7, height: 50.7 },
  xl: { width: 50.7, height: 50.7 },
  xxl: { width: 50.7, height: 50.7 },
};

const inputClassMap: Record<Size, string> = {
  sm: 'w-[328px] h-[44px] pt-[11px] pr-[24px] pb-[11px] pl-spacing-xs gap-spacing-none bg-color-background-input-default focus:border-[1px] focus:border-color-border-Input-focused rounded-radius-sm text-fontSize-inputField-sm leading-lineHeight-xl font-[450]',
  md: 'w-[426px] h-[58px] pt-[14.3px] pr-[31.2px] pb-[14.3px] pl-[20.8px] bg-color-background-input-default focus:border-[1.3px] focus:border-color-border-Input-focused rounded-radius-md gap-spacing-none text-fontSize-inputField-md leading-lineHeight-2xl font-[450]',
  lg: 'w-[554px] h-[75px] pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] bg-color-background-input-default focus:border-[1.69px] focus:border-color-border-Input-focused rounded-radius-md gap-spacing-none text-fontSize-inputField-lg leading-lineHeight-4xl font-[450]',
  xl: 'w-[554px] h-[75px] pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] bg-color-background-input-default focus:border-[1.69px] focus:border-color-border-Input-focused rounded-radius-md gap-spacing-none text-fontSize-inputField-lg leading-lineHeight-4xl font-[450]',
  xxl: 'w-[720px] h-[96px] pt-[24.167px] pr-[52.728px] pb-[24.167px] pl-[35.152px] bg-color-background-input-default focus:border-[2.197px] focus:border-color-border-Input-focused rounded-radius-lg gap-spacing-none text-fontSize-inputField-xl leading-lineHeight-7xl font-[450]',
};

const searchInputClassMap: Record<Size, string> = {
  sm: 'w-[328px] h-[44px] pt-[11px] pr-[24px] pb-[11px] pl-spacing-xs gap-spacing-none bg-color-background-input-default focus:border-[1px] focus:border-color-border-Input-focused rounded-radius-7xl text-fontSize-inputField-sm leading-lineHeight-xl font-[450]   focus:outline-0',
  md: 'w-[426px] h-[58px] pt-[14.3px] pr-[31.2px] pb-[14.3px] pl-[20.8px] bg-color-background-input-default focus:border-[1.3px] focus:border-color-border-Input-focused rounded-radius-7xl gap-spacing-none text-fontSize-inputField-md leading-lineHeight-2xl font-[450]   focus:outline-0',
  lg: 'w-[554px] h-[75px] pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] bg-color-background-input-default focus:border-[1.69px] focus:border-color-border-Input-focused rounded-radius-7xl gap-spacing-none text-fontSize-inputField-lg leading-lineHeight-4xl font-[450]   focus:outline-0',
  xl: 'w-[554px] h-[75px] pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] bg-color-background-input-default focus:border-[1.69px] focus:border-color-border-Input-focused rounded-radius-7xl gap-spacing-none text-fontSize-inputField-lg leading-lineHeight-4xl font-[450]   focus:outline-0',
  xxl: 'w-[554px] h-[75px] pt-[18.59px] pr-[40.56px] pb-[18.59px] pl-[27.04px] bg-color-background-input-default focus:border-[1.69px] focus:border-color-border-Input-focused rounded-radius-7xl gap-spacing-none text-fontSize-inputField-lg leading-lineHeight-4xl font-[450]   focus:outline-0',
};

const modelContentClassMap: Record<Size, string> = {
  sm: '!items-start mt-12',
  md: '!items-start mt-16',
  lg: '!items-start',
  xl: '!items-start',
  xxl: '!items-start',
};

const searchIconClassMap: Record<Size, string> = {
  sm: 'max-h-[27px] max-w-[27px] right-4 absolute z-[99]',
  md: 'max-h-[35.1px] max-w-[35.1px] absolute right-4 z-[99]',
  lg: 'max-h-[45.63px] max-w-[45.63px] absolute right-4 z-[99]',
  xl: 'max-h-[45.63px] max-w-[45.63px] absolute right-4 z-[99]',
  xxl: 'max-h-[45.63px] max-w-[45.63px] absolute right-4 z-[99]',
};
const searchListClassMap: Record<Size, string> = {
  sm: 'min-w-[360px] text-fontSize-paragraph-body-sm leading-line-height-xl',
  md: 'min-w-[768px] text-fontSize-paragraph-body-md leading-line-height-2xl',
  lg: 'max-w-[768px] text-fontSize-paragraph-body-lg leading-line-height-4xl',
  xl: 'max-w-[768px] text-fontSize-paragraph-body-lg leading-line-height-4xl',
  xxl: 'max-w-[768px] text-fontSize-paragraph-body-lg leading-line-height-4xl',
};

const searchHeadingClassMap: Record<Size, string> = {
  sm: ' font-[700] text-color-content-text-primary  text-fontSize-heading-planCardTitle-sm leading-lineHeight-lg  ',
  md: ' font-[700] text-color-content-text-primary text-fontSize-heading-planCardTitle-md leading-lineHeight-xl  ',
  lg: ' font-[700] text-color-content-text-primary text-fontSize-heading-planCardTitle-lg leading-lineHeight-2xl  ',
  xl: ' font-[700] text-color-content-text-primary text-fontSize-heading-planCardTitle-lg leading-lineHeight-2xl  ',
  xxl: ' font-[700] text-color-content-text-primary text-fontSize-heading-planCardTitle-lg leading-lineHeight-2xl  ',
};

const searchListLabelClassMap: Record<Size, string> = {
  sm: 'relative flex items-center py-[10px] px-spacing-xs',
  md: 'relative flex items-center pt-spacing-xs pr-spacing-xs pb-spacing-xs pl-spacing-12xl',
  lg: 'relative flex items-center pt-spacing-xs pr-spacing-xs pb-spacing-xs pl-spacing-12xl',
  xl: 'relative flex items-center pt-spacing-xs pr-spacing-xs pb-spacing-xs pl-spacing-12xl',
  xxl: 'relative flex items-center pt-spacing-xs pr-spacing-xs pb-spacing-xs pl-spacing-12xl',
};

const errorMsgContainerClassMap: Record<Size, string> = {
  sm: 'text-fontSize-paragraph-body-3xs text-red-500 ',
  md: 'text-fontSize-paragraph-body-2xs text-red-500 ',
  lg: 'text-fontSize-paragraph-body-xs text-red-500 ',
  xl: 'text-fontSize-paragraph-body-xs text-red-500 ',
  xxl: 'text-fontSize-paragraph-body-sm text-red-500 ',
};

const iconSizeClassMap: Record<Size, string> = {
  sm: 'h-[30px] w-[30px]',
  md: 'h-[39px] w-[39px]',
  lg: 'h-[50.7px] w-[50.7px]',
  xl: 'h-[50.7px] w-[50.7px] ',
  xxl: 'h-[50.7px] w-[50.7px]',
};

const noResultTitleClassMap: Record<Size, string> = {
  sm: 'text-font-size-heading-sectionTitle-h2-md text-color-content-text-primary font-[900]',
  md: 'text-font-size-heading-sectionTitle-h2-md text-color-content-text-primary font-[900]',
  lg: 'text-font-size-heading-sectionTitle-h2-md text-color-content-text-primary font-[900]',
  xl: 'text-font-size-heading-sectionTitle-h2-md text-color-content-text-primary font-[900]',
  xxl: 'text-font-size-heading-sectionTitle-h2-md text-color-content-text-primary font-[900]',
};

const noResultDescClassMap: Record<Size, string> = {
  sm: 'text-fontSize-paragraph-body-sm text-color-content-text-secondary ',
  md: 'text-fontSize-paragraph-body-md text-color-content-text-secondary ',
  lg: 'text-fontSize-paragraph-body-lg text-color-content-text-secondary ',
  xl: 'text-fontSize-paragraph-body-lg text-color-content-text-secondary ',
  xxl: 'text-fontSize-paragraph-body-lg text-color-content-text-secondary ',
};
export {
  paymentContainerClassMap,
  paymentHeadingClassMap,
  paymentCardContainerClassMap,
  cardsContainerClassMap,
  imageTextContainerClassMap,
  cardIconClassMap,
  cardTitleClassMap,
  checkBoxContainerClassMap,
  checkBoxRowClassMap,
  checkBoxClassMap,
  checkBoxLabelClassMap,
  checkBoxLinkLabelClassMap,
  creditCheckLinkLabelClassMap,
  iconClassMap,
  inputClassMap,
  selectedCardClassMap,
  checkBoxIconClassMap,
  modelContentClassMap,
  searchIconClassMap,
  searchListClassMap,
  searchHeadingClassMap,
  searchInputClassMap,
  searchListLabelClassMap,
  errorMsgContainerClassMap,
  iconSizeClassMap,
  noResultDescClassMap,
  noResultTitleClassMap,
  creditCheckMessageClassMap,
  cardIconSizeMap,
  bankIconPaddingSizeMap,
};
